module.exports = __webpack_public_path__ + "static/media/alcohol-and-addictions@3x.f9aa7fc2.png";